import * as React from 'react';
import axios from 'axios';

type FullPlayerProps = {
  episode: {
    id: number,
  },
  onFinish: Function,
  onProgress?: Function,
}
export default class FullPlayer extends React.Component<FullPlayerProps> {
  constructor(props) {
    super(props);
  }

  private player;
  private progressUpdater;
  private progressInSeconds;

  state = {
    episode: null,
  }

  componentDidMount() {
    const { onProgress } = this.props;

    this.player = (window as any).videojs('video_player', {
      controlBar: {
        pictureInPictureToggle: false,
      },
      playbackRates: [0.5, 1, 1.5, 2],
    });
    this.player.on('ended', () => {
      this.props.onFinish(); 
    });

    this.fetchEpisode(this.props.episode.id, { play: false} );


    this.player.on('timeupdate', (_) => {
      this.progressInSeconds = this.player.currentTime();
      if(!this.progressUpdater) {
        this.progressUpdater = setTimeout(() => { 
          console.log("Progress is ", this.progressInSeconds);
          if(this.progressInSeconds > 5) {
            onProgress(this.progressInSeconds); 
          }
          this.progressUpdater = null;
        },5000); // Update progress every 15 seconds
      }
    });
  }

  fetchEpisode = (episodeId, options = { play: false }) => {
    axios.get((window as any).API_URL + '/episodes/'+episodeId, {
      params: { token: (window as any).API_TOKEN },
    }).then( response => {
      const episode = response.data.data;
      this.setState({
        episode: episode
      });
      
      this.player.reset();
      this.player.poster(episode.thumbnail_url);
      this.player.src([
        { type: "application/x-mpegURL", src: episode.streams.hls.urls.https, },
        { type: "video/mp4", src: episode.streams['720p'].urls.https, }
      ]);

      if(episode.tracks.length > 0) {
        const en = episode.tracks[0];
        
        this.player.addRemoteTextTrack({
          kind: en.kind,
          label: en.label,
          srclang: en.lang,
          src: en.url,
          mode: 'showing',
        });
      } 

      if(options.play) {
        this.player.play();
      }
    });
    
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.episode.id !== this.props.episode.id) {
      this.fetchEpisode(nextProps.episode.id, { play: true })
    }
  }

  render() {
    return (
      <div className="preview-player">
        <video id="video_player" className="video-js" controls preload="auto"></video>
      </div>
    );
  }
}

